// Reapply as variants arrive; do not disable every level before heights are known.
export function applyPlaybackQuality (levels, highest) {
  const variants = Array.from({ length: levels.length }, (_, i) => levels[i])
  const height = Math.max(0, ...variants.map(level => level.height || 0))
  variants.forEach(level => { level.enabled = !highest || !height || level.height === height })
}

// Auto plays the highest quality the connection keeps up with (owner, 2026-11-04): it is not
// capped by the player's size, and it starts at the top rendition, stepping down only when
// segments arrive too slowly. "Highest" (applyPlaybackQuality) keeps the top one regardless.
export const PLAYBACK_VHS_DEFAULTS = Object.freeze({
  limitRenditionByPlayerDimensions: false,
  // The starting bandwidth estimate in bits per second, above any rendition in our ladder.
  bandwidth: 20000000
})

export const withPlaybackDefaults = (options = {}) => ({
  ...options,
  html5: {
    ...options.html5,
    vhs: { ...PLAYBACK_VHS_DEFAULTS, ...options.html5?.vhs }
  }
})
